export default "__VITE_ASSET__CFlgYy4C__"